import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET_ALL: 'SUBSCRIPTION_PRODUCTS_GET_ALL',
  GET_ALL_SUCCESS: 'SUBSCRIPTION_PRODUCTS_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'SUBSCRIPTION_PRODUCTS_GET_ALL_FAILURE',
};

export const getAll = actions.getAll(() => `${BASE_URL}/payment/subscription-products/`, {
  PENDING: ACTIONS.GET_ALL,
  SUCCESS: ACTIONS.GET_ALL_SUCCESS,
  FAILURE: ACTIONS.GET_ALL_FAILURE,
});
